import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    --bc-brand-primary-00: #2c2a29;
    --bc-bg-secondary-off: rgba(44, 42, 41, 0.8);
    --bc-bg-gray-neutro: #F2F2F4;
    --bc-bg-primary-01: #ffffff;
    --bc-brand-secondary-press-00: #b3b5b8;
    --bc-brand-secondary-hover-00: #d9dadd;
    
  }
  * {
    -webkit-font-smoothing: antialiased;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  #auth {
    padding:0;
  }
  nav.mega-menu-principal-container.hidden {
    transform: translateY(-100%);
  }

  nav.mega-menu-principal-container.visible {
    transform: translateY(0);
  }
  nav.mega-menu-principal-container {
    
    width: 100%;
    height: 52px;
    padding: 0 0.5rem;
    background-color: var(--bc-bg-primary-01);
    position: fixed;
    top: 0;
    transition: transform 0.3s ease-in-out;
    z-index: 998;
    box-shadow: 0px 1px 4px 0px #2C2A2929;
    box-sizing: border-box;
    & .core-options-container {
      align-items: center;
      & em.icon {
        display: block;
        padding: 4px;
        border-radius: 6px;
        cursor: pointer;
        height: max-content;
        align-self: center;

        &:hover {
          background-color: var(--bc-brand-secondary-hover-00);
        }
        &:active {
          background-color: var(--bc-brand-secondary-press-00);
        }
      }
    }
    & .right-actions{
      & li {
        margin-left: 16px;
        font-family: "CIB Sans Bold";
        }
        & span{
          display: none;
        }
      }
      #mobile-nav {
        span {
          display: block;
        }
      }
    }
    
    section.submenu-container {
      width: 100%;
      height: calc(100vh - 48px);
      background-color: var(--bc-bg-primary-01);
      font-family: 'Open Sans';
      position: fixed;
      top: 48px;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.5s ease, visibility 0.5s ease;
      z-index: 1000;
      & section.submenu-container-left {
        width: 100%;
        overflow: auto;
        & .mobile-opts {
          & .core-option {
            & div.core-option-btn {
              box-sizing: border-box;
                color: var(--bc-brand-primary-00);
                width: 100%;
                padding: 13px;
                background: transparent;
                border: none;
                border-bottom: 1px solid var(--bc-brand-secondary-hover-00);
              & img {
                width: 200px;
              }
              & img[alt="Tu360Compras"] {
                width: 190px;
              }
              & img[alt="Tu360Inmobiliario"] {
                width: 225px;
              }
            }
            & .mobile-categories {
              width: 100%;
              max-height: 0;
              overflow: hidden;
              transition: max-height 0.3s ease-in-out;
              & .category-option {
                & div.category-option__content {
                  width: 100%;
                  & div {
                    padding: 13px;
                    width: 100%;
                    border-bottom: none;
                    font-size: 16px;
                    font-family: 'Open Sans';
                  }
                  & .arrow {
                    font-size: 1rem;
                    padding: 13px;
                  }
                }
                & .categories-opts {
                  max-height: 0;
                  overflow: hidden;
                  transition: max-height 0.3s ease-in-out;
                  width: 100%;
                  background-color: var(--bc-bg-gray-neutro);
                  & .category-opt {
                    margin: 0 13px;
                    border-bottom: 1px solid var(--bc-brand-secondary-hover-00);
                    &:last-of-type {
                      padding-bottom: 24px;
                    }
                    & h3 {
                      margin: 12px 0;
                      font-family: "CIB Sans Bold";
                    }
                    .option {
                      a {
                        display: block;
                        padding: 12px 0;
                      }
                    }
                  }
                  & .more-info {
                    padding: 8px 16px;
                    font-family: "CIB Sans Bold";
                  }
                }
              }
              & .category-option--active  {
                & div.category-option__content div {
                  font-family:'Open Sans Bold';
                }
                & .categories-opts {
                    max-height: 3000px;
                }
              }
            }
            & .mobile-categories--active {
              max-height: 3000px;
            }
          }
          & .core-option--active {
            & div.core-option-btn{
              border-bottom: 4px solid var(--color, var(--bc-brand-primary-00));
              background-color: var(--bc-brand-primary-00);
              color: var(--bc-bg-primary-01);
              & img {
                filter: invert(1);
              }
            }
          }
        }
        
        .submenu-option {
          text-align: center;
        }
        
      }
    }
    section.submenu-container--active {
      opacity: 1;
      visibility: visible;
    }
  }

  
  
`;
